"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatMessagesList = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _reactTinyVirtualList = _interopRequireDefault(require("react-tiny-virtual-list"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _css = _interopRequireDefault(require("@styled-system/css"));

var _Layout = require("../Layout");

var _Buttons = require("../Buttons");

var _ChatMessage = require("../ChatMessage");

var _Typography = require("../Typography");

var StyledChatMessagesList = (0, _styledComponents.default)(_Layout.Box).withConfig({
  displayName: "ChatMessagesList__StyledChatMessagesList",
  componentId: "iiv5wh-0"
})(_styledSystem.layout, (0, _css.default)({
  overflow: 'hidden'
}));

function getStyleFromElement(element, strCssRule) {
  var strValue = '';

  if (document.defaultView && document.defaultView.getComputedStyle) {
    strValue = document.defaultView.getComputedStyle(element, '').getPropertyValue(strCssRule);
  } else if (element.currentStyle) {
    var cssRuleFiltered = strCssRule.replace(/\-(\w)/g, function (strMatch, p1) {
      return p1.toUpperCase();
    });
    strValue = element.currentStyle[cssRuleFiltered];
  }

  return strValue;
}

function getNumberFromPixels(value) {
  return Number(String(value).replace('px', ''));
}

var GoToLastMessageButton = function GoToLastMessageButton(_ref) {
  var scrollToLastMessage = _ref.scrollToLastMessage,
      goToLastButtonMessage = _ref.goToLastButtonMessage;
  return _react.default.createElement(_Layout.Flex, {
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    bottom: 5,
    position: "absolute"
  }, _react.default.createElement(_Buttons.Button, {
    type: "rounded",
    action: scrollToLastMessage,
    size: "tiny",
    color: "rambutan"
  }, _react.default.createElement(_Typography.Text, {
    color: "coco",
    size: "micro"
  }, goToLastButtonMessage)));
};

var ChatMessagesList = function ChatMessagesList(_ref2) {
  var chatMessages = _ref2.chatMessages,
      goToLastButtonMessage = _ref2.goToLastButtonMessage,
      props = (0, _objectWithoutProperties2.default)(_ref2, ["chatMessages", "goToLastButtonMessage"]);

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      messages = _useState2[0],
      _setMessages = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      chatMessagesHeight = _useState4[0],
      setChatMessagesHeight = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      virtualListHeight = _useState6[0],
      setVirtualListHeight = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      showGoToLastButton = _useState8[0],
      setShowGoToLastButton = _useState8[1];

  var _useState9 = (0, _react.useState)({}),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      virtualListProps = _useState10[0],
      setVirtualListProps = _useState10[1];

  var messagesRef = (0, _react.useRef)([]);

  var setMessages = function setMessages(data) {
    messagesRef.current = data;

    _setMessages(data);
  };

  var scrollToLastMessage = function scrollToLastMessage() {
    var _messagesRef$current;

    setVirtualListProps({
      scrollToIndex: ((_messagesRef$current = messagesRef.current) === null || _messagesRef$current === void 0 ? void 0 : _messagesRef$current.length) - 1
    });
    setTimeout(function () {
      setVirtualListProps({
        scrollToIndex: null
      });
    });
  };

  var onItemsRendered = function onItemsRendered(_ref3) {
    var stopIndex = _ref3.stopIndex;

    if (stopIndex === messagesRef.current.length - 1) {
      setShowGoToLastButton(false);
      return;
    }

    setShowGoToLastButton(true);
  };

  var calculateVirtualListHeight = function calculateVirtualListHeight(node) {
    if (node !== null) {
      var nodeHeight = node.getBoundingClientRect().height;

      if (chatMessagesHeight !== nodeHeight) {
        setChatMessagesHeight(nodeHeight);
        var paddingTop = getNumberFromPixels(getStyleFromElement(node, 'padding-top'));
        var paddingBottom = getNumberFromPixels(getStyleFromElement(node, 'padding-bottom'));
        var ancestorHeight = nodeHeight;
        setVirtualListHeight(ancestorHeight - (paddingTop + paddingBottom));
      }
    }
  };

  (0, _react.useEffect)(function () {
    if (chatMessages !== null && chatMessages !== void 0 && chatMessages.length) {
      setMessages([].concat((0, _toConsumableArray2.default)(chatMessages), [{
        footer: true,
        height: 1
      }]));

      if (!showGoToLastButton) {
        scrollToLastMessage();
      }
    }
  }, [chatMessages]);
  return _react.default.createElement(StyledChatMessagesList, (0, _extends2.default)({}, props, {
    paddingY: 5,
    position: "relative",
    ref: calculateVirtualListHeight
  }), _react.default.createElement(_reactTinyVirtualList.default, (0, _extends2.default)({
    width: "100%",
    height: virtualListHeight,
    itemCount: messages.length,
    itemSize: function itemSize(index) {
      return messages[index].height;
    },
    onItemsRendered: onItemsRendered,
    style: {
      paddingLeft: '16px',
      paddingRight: '16px'
    }
  }, virtualListProps, {
    renderItem: function renderItem(_ref4) {
      var index = _ref4.index,
          style = _ref4.style;
      var _messages$index = messages[index],
          footer = _messages$index.footer,
          itemProps = (0, _objectWithoutProperties2.default)(_messages$index, ["footer"]);
      return _react.default.createElement("div", {
        key: index,
        style: style
      }, footer && _react.default.createElement("div", null), !footer && _react.default.createElement(_ChatMessage.ChatMessage, (0, _extends2.default)({
        width: "100%"
      }, itemProps)));
    }
  })), showGoToLastButton && _react.default.createElement(GoToLastMessageButton, {
    scrollToLastMessage: scrollToLastMessage,
    goToLastButtonMessage: goToLastButtonMessage
  }));
};

exports.ChatMessagesList = ChatMessagesList;
ChatMessagesList.defaultProps = {
  chatMessages: [],
  width: '380px',
  height: '100%'
};